module.exports = "https://wrf-static.prod-my.games/promo/long-lp/img/slide-2.abf2f97a.webp";